import MarketplaceCatalogView from "./MarketplaceCatalogView";

export { MarketplaceCatalogView };
